import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { token } from '@atlaskit/tokens';

import { SignupBackgroundLayout } from '@/components/signup/layouts/signup-background-layout';
import { NewUser } from '@/components/signup/site-activation/components/new-user/new-user';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';
import { RovoDevAgentsLogo } from '@/components/signup/utils/logos/rovo-dev-agents-logo';

import { CreateASiteHeading } from '../../components/create-a-site-heading';
import { SignupFormWithPaymentSwitcher } from '../../components/payment/signup-form-with-payment-switcher';
import { PrivacyPolicy } from '../../components/privacy-policy';

export const LoggedInRovoDevStandardNewUser = () => {
	const intl = useIntl();

	const subHeaderText = intl.formatMessage({
		id: 'siteActivation.loggedInRovoDev.newUser',
		defaultMessage: 'Sites are the shared space where people organize teams, work, and projects.',
	});

	return (
		<SignupBackgroundLayout theme="green" ProductLogo={<RovoDevAgentsLogo />}>
			<div css={containerCss}>
				<SiteActivation
					NewUser={
						<SignupFormWithPaymentSwitcher
							header={
								<div css={headerGroupCss}>
									<h1 css={headerCss}>
										<span css={accentImageSpanCss}>
											<CreateASiteHeading />
										</span>
									</h1>
									<p css={headerCss}>{subHeaderText}</p>
								</div>
							}
						>
							<NewUser PrivacyPolicy={<PrivacyPolicy />} />
						</SignupFormWithPaymentSwitcher>
					}
				/>
			</div>
		</SignupBackgroundLayout>
	);
};

const containerCss = css({
	display: 'flex',
	flexDirection: 'column',
});

const headerGroupCss = css({
	display: 'grid',
	gap: token('space.100'),
});

const headerCss = css({
	margin: 0,
	textAlign: 'center',
});

const accentImageSpanCss = css({
	position: 'relative',
});
